<ion-row class="ion-nowrap row-m">
  <ion-col class="view-button-m">
    <ion-button
      class="hundred"
      strong="true"
      [style.display]="_chartTypes.Aar.visible ? 'inline-block' : 'none'"
      [class]="_chartTypes.Aar.active ? 'hydrated dark' : 'hydrated'"
      (click)="setChartType('Aar')"
      ><b>År</b></ion-button
    >
  </ion-col>
  <ion-col class="view-button-m">
    <ion-button
      class="hundred"
      strong="true"
      [style.display]="_chartTypes.Maaned.visible ? 'inline-block' : 'none'"
      [class]="_chartTypes.Maaned.active ? 'hydrated dark' : 'hydrated'"
      (click)="setChartType('Maaned')"
      ><b>Måned</b></ion-button
    >
  </ion-col>
  <ion-col class="view-button-m">
    <ion-button
      class="hundred"
      strong="true"
      [style.display]="_chartTypes.Dag.visible ? 'inline-block' : 'none'"
      [class]="_chartTypes.Dag.active ? 'hydrated dark' : 'hydrated'"
      (click)="setChartType('Dag')"
      ><b>Dag</b></ion-button
    >
  </ion-col>
  <ion-col class="view-button-m">
    <ion-button
      class="hundred"
      strong="true"
      [style.display]="_chartTypes.Time.visible ? 'inline-block' : 'none'"
      [class]="_chartTypes.Time.active ? 'hydrated dark' : 'hydrated'"
      (click)="setChartType('Time')"
      ><b>Time</b></ion-button
    >
  </ion-col>
</ion-row>
